import history from 'mgr/pages/shared/utils/History'

export const redirectBackToMenu = (venueUrlKey, siteUrlKey) => {
  history.push(`/${getMenuUrl(venueUrlKey, siteUrlKey)}`)
}

export const getMenuUrl = (venueUrlKey, siteUrlKey) => `explore/${venueUrlKey}/ordering/${siteUrlKey}`
